import type { FC } from 'react';

export const DeepgramLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/deepgram-logo.png"
      alt="Deepgram"
      className="w-full h-full object-contain"
    />
  </div>
);
